import { CIcon } from '~/icons/types'

export const ciSquareMeters: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.392 13.75a.75.75 0 0 0-.75.75v6.749h-8.066V14.5a.75.75 0 1 0-1.5 0v7.064a1.186 1.186 0 0 0 1.185 1.185h8.7a1.186 1.186 0 0 0 1.185-1.185V14.5a.749.749 0 0 0-.754-.75Z'
    },
    {
      d:
        'M15.754 6.966a1.7 1.7 0 0 0-2.23-.054l-6.776 5.44a.75.75 0 1 0 .939 1.17l6.837-5.5c.04-.04.13-.04.23.055l6.776 5.44a.751.751 0 0 0 .94-1.17l-6.716-5.381ZM4.948 8.616a.75.75 0 1 0 1.06-1.06L4.27 5.815a.76.76 0 0 0-.677-.204.753.753 0 0 0-.384.204l-1.74 1.74a.75.75 0 1 0 1.06 1.06l.46-.459V20.19l-.46-.459a.75.75 0 0 0-1.06 1.061l1.74 1.74a.742.742 0 0 0 .1.066c.043.036.09.068.14.093a.738.738 0 0 0 .578 0 .702.702 0 0 0 .14-.093.692.692 0 0 0 .1-.067l1.739-1.739a.75.75 0 1 0-1.061-1.06l-.46.458V8.157l.463.46ZM22.75 3.739a.494.494 0 0 0-.014-.067.732.732 0 0 0-.044-.22.75.75 0 0 0-.165-.245L20.791 1.47a.75.75 0 1 0-1.061 1.06l.458.459H8.159l.458-.458a.75.75 0 0 0-1.06-1.061L5.82 3.207a.674.674 0 0 0-.209.465c0 .023-.013.043-.013.067 0 .099.02.197.058.289a.74.74 0 0 0 .084.125c.022.04.048.08.077.116l1.74 1.739a.75.75 0 0 0 1.06-1.061l-.459-.46H20.19l-.46.46a.751.751 0 0 0 1.061 1.06L22.53 4.27a.688.688 0 0 0 .078-.116.73.73 0 0 0 .083-.125.75.75 0 0 0 .059-.29Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'square-meters',
  type: 'light'
}
